import manifest from './optimizedImageManifest.json';

// Only use variants generated for this site's assets. API uploads remain unchanged.
export const getOptimizedImageUrl = (url) => {
  if (typeof url !== 'string' || !url) return url;
  try {
    const parsed = new URL(url, 'https://iskenderun.bel.tr');
    if (!['https://iskenderun.bel.tr', 'http://iskenderun.bel.tr', 'https://www.iskenderun.bel.tr', 'http://www.iskenderun.bel.tr'].includes(parsed.origin)) return url;
    const optimized = manifest[parsed.pathname];
    return optimized ? `${optimized}${parsed.search}${parsed.hash}` : url;
  } catch {
    return url;
  }
};
